export default "__VITE_ASSET__dDpo8$iw__"